import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse, PaginatedApiResponse } from '@shared/models/securepay';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChargeBack {
  private http = inject(HttpClient);
  private baseUrl = environment.baseAPI;

  getAllChargebacks(params: Record<string, any> = {}) {
    let url = `${this.baseUrl}/api/chargeback/merchant/chargebacks`;
    const keys = Object.keys(params);
    if (keys.length > 0) {
      const queryString = keys
        .filter(
          (key) =>
            params[key] !== undefined &&
            params[key] !== null &&
            params[key] !== '',
        )
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
        )
        .join('&');

      url += url.includes('?') ? '&' + queryString : '?' + queryString;
    }
    return this.http.get<ApiResponse<PaginatedApiResponse<any[]>>>(url);
  }

  getChargebackById(chargebackId: string) {
    const id = encodeURIComponent(chargebackId);
    return this.http.get<ApiResponse<Record<string, unknown>>>(
      `${this.baseUrl}/api/chargeback/merchant/chargebacks/${id}`,
    );
  }

  acceptChargeBack(payload: {
    chargebackId: string;
    merchantComment?: string;
  }) {
    return this.http.post(
      `${this.baseUrl}/api/chargeback/merchant/${payload.chargebackId}/accept`,
      payload,
    );
  }

  declineChargeBack(payload: {
    chargebackId: string;
    merchantComment: string;
    proofFileUrl: any;
  }) {
    const formData = new FormData();
    formData.append('merchantComment', payload.merchantComment);
    formData.append(
      'proofDocument',
      payload.proofFileUrl,
      payload.chargebackId,
    );
    return this.http.post(
      `${this.baseUrl}/api/chargeback/merchant/${payload.chargebackId}/decline`,
      formData,
    );
  }
}
